import { Ava, GetTimeFromTimestamp } from '@dave/types';
import { SelectSearchOption } from '../../dave-utils-module/select-search/components/select-search/select-search.component';

export enum AvaStatus {
    Erstellt = 'Erstellt',
    Ausgeschrieben = 'Ausgeschrieben',
    Vergeben = 'Vergeben',
}
export const AvaStatusLabels: Record<AvaStatus, string> = {
    [AvaStatus.Erstellt]: 'Erstellt',
    [AvaStatus.Ausgeschrieben]: 'Ausgeschrieben',
    [AvaStatus.Vergeben]: 'Vergeben',
};
export const AvaStatusAvailableNextStatus: Record<AvaStatus, AvaStatus[]> = {
    [AvaStatus.Erstellt]: [AvaStatus.Erstellt, AvaStatus.Ausgeschrieben, AvaStatus.Vergeben],
    [AvaStatus.Ausgeschrieben]: [AvaStatus.Ausgeschrieben, AvaStatus.Vergeben],
    [AvaStatus.Vergeben]: [AvaStatus.Vergeben ],
};

export class AvaEntity implements SelectSearchOption {
    constructor(
        public Id: number = null,
        public Name: string = null,
        public Description: string = null,
        public UpdatedAt: Date = null,
        public CreatedAt: Date = null,
        public AvaNumber: string = null,
        public CustomerId: number = null,
        public CommissionId: number = null,
        public EstimatedCostTarget: number = null,
    ) {}
    public static EntityName = 'AVA';
    public static EntityPropertyNames: Map<keyof AvaEntity, string> = new Map([['UpdatedAt', 'Aktualisiert am']]);
    public get DisplayName(): string {
        return this.Name;
    }
    public get optionLabel(): string {
        return this.DisplayName;
    }
    public Clone(override: Partial<AvaEntity> = {}): AvaEntity {
        const attr = { ...this, ...override };
        return Object.assign(new AvaEntity(), attr);
    }
    public static fromBackend(res: Ava): AvaEntity {
        return new AvaEntity(
            res.Id && +res.Id,
            res.Title,
            res.Description,
            res.UpdatedAt && GetTimeFromTimestamp(+res.UpdatedAt),
            res.CreatedAt && GetTimeFromTimestamp(+res.CreatedAt),
            // res.Status,
            res.AvaNumber,
            res.CustomerId ? +res.CustomerId : null,
            res.CommissionId ? +res.CommissionId : null,
            res.EstimatedCostTarget ? +res.EstimatedCostTarget : null,// todo res.Budget
        );
    }
}
